import { cssVar, Text, DataList, DataItem } from '@cad-arc';
import { compact } from 'lodash';
import { observer } from 'mobx-react-lite';
import { useEventMetadataStore } from './event-metadata';
import { formatPhoneNumber } from './helpers/person-helpers';

export const EventPanelFormReadOnlyReportingPartyFields = observer(() => {
    const reportingParty = useEventMetadataStore().state.metadata?.primaryReportingParty;

    return (
        <DataList spacing={1}>
            <DataItem
                style={{
                    fontSize: cssVar('arc.fontSizes.sm'),
                }}
                dataKey="RP"
            >
                <Text fontWeight="semibold">
                    {compact([
                        reportingParty?.fullName,
                        reportingParty?.phoneNumber
                            ? formatPhoneNumber(reportingParty.phoneNumber)
                            : undefined,
                        reportingParty?.phoneExtension
                            ? `Ext. ${reportingParty.phoneExtension}`
                            : undefined,
                        reportingParty?.locationDisplay,
                    ]).join(', ') || undefined}
                </Text>
            </DataItem>
            <DataItem
                style={{
                    fontSize: cssVar('arc.fontSizes.sm'),
                }}
                dataKey="RP Notes"
            >
                <Text fontWeight="semibold">{reportingParty?.notes ?? undefined}</Text>
            </DataItem>
        </DataList>
    );
});
